export default __webpack_public_path__ + "static/media/location-icon.477ab4c4.png";